package dk.smark.demo

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.ComposeViewport
import dk.smark.demo.location.GenericLocation
import dk.smark.demo.map.MapController
import dk.smark.demo.map.OsmMap
import dk.smark.demo.ui.CenterOnUserButton

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport {
        val controller = MapController()
        App(
            mapComponent = {l -> MapComponent(controller=controller, location=l)},
            onUserLocationFound = {lat,lon -> controller.pinUserLocation(lat,lon)},
            onTrackAvailable = { controller.renderTrack(it) },
            bannerAd = {BannerAd()})
    }
}

@Composable
fun MapComponent(controller: MapController, location: GenericLocation) {
    Box {
        OsmMap(
            controller = controller,
            modifier = Modifier.fillMaxSize(),
            onEvent = controller::onEvent,
        )
    }
}

@Composable
fun BannerAd() {
    Text("BannerAd")
}

